import _ from 'lodash';
import { createSelector } from 'reselect';
import { formValueSelector } from 'redux-form';

import { INGREDIENT_GROUPS_FORM_NAME } from 'Common/FormEnum';
import {
  IngredientSourceFieldEnum,
  IngredientGroupFieldEnum,
} from 'Common/FieldEnum';
import { makeOptionsData } from 'Common/FormHelper';
import { createMap } from 'Common/Helpers/format';

const root = state => _.get(state, 'ControlInformationState.ingredientGroup');

export const getIngredientGroupError = state =>
  _.get(root(state), 'error', null);

export const getIngredientGroupLoading = state =>
  _.get(root(state), 'loading', false);

export const getIngredientGroupSaved = state =>
  _.get(root(state), 'writeSuccessful', false);

export const getIngredientGroupDeleted = state =>
  _.get(root(state), 'deleteSuccessful', false);

export const getIngredientSources = state =>
  _.get(root(state), 'ingredientSources', []);

export const getIngredientSourcesOptions = createSelector(
  getIngredientSources,
  ingredientSources => {
    return makeOptionsData(ingredientSources, {
      keyKey: IngredientSourceFieldEnum.Id,
      valueKey: IngredientSourceFieldEnum.Id,
      textKeys: [IngredientSourceFieldEnum.ShortDesc],
    });
  }
);

export const getIngredientSourcesMap = createSelector(
  getIngredientSources,
  ingredientSources => createMap(ingredientSources)
);

export const getIngredientGroupValue = formValueSelector(
  INGREDIENT_GROUPS_FORM_NAME
);

export const getIsIngredientGroupReadOnly = (state, field) => {
  const ingredientSourcesMap = getIngredientSourcesMap(state);

  const ingGroup = getIngredientGroupValue(state, field);
  const isSourceReadOnly = _.get(
    ingredientSourcesMap,
    [ingGroup[IngredientGroupFieldEnum.IngredientSourceId], 'ReadOnly'],
    true
  );

  return isSourceReadOnly;
};



// WEBPACK FOOTER //
// ./src/pages/controlinformation/state/ingredientGroup/selectors.js